import { Subscription } from 'rxjs';
import Logger from '../../js/lib/logger';
import { estimate$ } from '../lib/state';
import { money } from '../lib/util.functions';

class PricingModal extends HTMLElement {
  #NAME = 'PricingModal';
  #sub: Subscription;
  #table: HTMLElement;

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#table = this.querySelector('[data-pricing-table]') as HTMLElement;
    this.#sub = estimate$.subscribe(dta => {
      const divs = []
      divs.push(this.#createDiv(dta.tray.title, dta.tray.price));
      dta.otherCharges.forEach(obj => divs.push(this.#createDiv(obj.title, obj.price, obj.quantity)));
      divs.push(this.#createDiv('Total', dta.otherCharges.map(c => c.quantity ? c.quantity * c.price : c.price)
                                                          .reduce((a,b) => a + b, dta.tray.price)));
      this.#table.append(...divs);
    });
  }

  connectedCallback(): void {
    Logger.info(`${this.#NAME} > connectedCallback`);
  }

  disconnectedCallback(): void {
    Logger.info(`${this.#NAME} > disconnectedCallback`);
    this.#sub.unsubscribe();
  }

  #createDiv(title: string, price: number, quantity?: number): HTMLElement {
    const div = document.createElement('DIV');
    const tspan = document.createElement('SPAN');
    const pspan = document.createElement('SPAN');
    tspan.textContent = quantity ? `${title} x ${quantity}`: title;
    pspan.textContent = quantity ? money(price * quantity) : money(price);
    div.append(tspan, pspan);
    return div
  }
}

customElements.define('pricing-modal', PricingModal);